import React, { useEffect, useState } from "react";
import "./FeedbackModal.scss";
import { Box, TextField, Typography, Slider } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import SnackbarAlert from "../../shared-components/snackbar-alert/SnackbarAlert";
import {
  getApplicantDetails,
  getOppprtunityDetails,
  saveRatingFeedback,
  setResetData,
} from "../new-booking-form/new-booking-form.slice";
import { useParams } from "react-router";
import {
  COMPARE_VALUE,
  ERROR_MESSAGE,
  BOOKING_FORM_STATUS,
} from "../../config/constant";
import ThankYouModal from "./ThankYouModal";
import Loader from "../../components/Loader";
import puravankarLogo from "../../../src/assets/images/thank-you-logo.png";
import ProvidentLogo from "../../../src/assets/icons/Provident.svg";
import PurvaLandLogo from "../../../src/assets/icons/Purva Land 1.svg";

import { useHistory } from "react-router-dom";
import { useHandleRedirection } from "../new-booking-form/hooks/useHandleRedirection";
const { REACT_APP_S3_BASE_URL } = process.env;
const FeedbackModal = () => {
  const [ratingAndFeedback, setRatingAndFeedback] = useState({
    rating: null,
    feedback: "",
  });
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const ratingList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const dispatch = useDispatch();
  const { oppId } = useParams();
  const history = useHistory();
  const { handleRedirection } = useHandleRedirection();

  const {
    isLoading,
    enquiryDetails,
    projectBrandImage,
    applicantData,
  } = useSelector((state) => state?.newBookingForm);

  const MAX = 10;
  const MIN = 0;
  const marks = [
    {
      value: MIN,
      label: "",
    },
    {
      value: MAX,
      label: "",
    },
  ];

  const [val, setVal] = useState(MIN);

  const handleChange = (_, newValue) => {
    setVal(newValue);
    setRatingAndFeedback({
      rating: newValue,
      feedback: ratingAndFeedback?.feedback,
    });
  };

  const getSliderColor = (value) => {
    if (value < 5) {
      // Transition from red to orange
      const red = 255;
      const green = Math.round((255 * value) / 5);
      return `rgb(${red}, ${green}, 0)`;
    } else {
      // Transition from orange to green
      const red = Math.round(255 - (255 * (value - 5)) / 5);
      const green = 255;
      return `rgb(${red}, ${green}, 0)`;
    }
  };

  useEffect(() => {
      if (applicantData?.opportunityId !== oppId) {
        dispatch(setResetData());
      }
    }, []);

  useEffect(() => {
    dispatch(getOppprtunityDetails(`/${oppId}`));
    dispatch(getApplicantDetails(`/${oppId}`))
      .unwrap()
      .then((res) => {
        if (res) {
          handleRedirection(res, "");
        }
      })
      .catch((error) => {
        setSnackbarConfig({
          open: true,
          message: ERROR_MESSAGE,
          severity: "error",
        });
        history.push(`/booking-form/${oppId}`);
      });
  }, []);

  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleSubmit = () => {
    let payload = {
      opportunityId: oppId || "",
      rating: ratingAndFeedback?.rating,
      feedback: ratingAndFeedback?.feedback || "",
    };
    dispatch(saveRatingFeedback(payload))
      .unwrap()
      .then((res) => {
        if (res?.statusCode === 200 || res?.statusCode === 201) {
          dispatch(getApplicantDetails(`/${oppId}`));
          setShowThankYouModal(true);
          setSnackbarConfig({
            open: true,
            message: res?.message,
            severity: "success",
          });
          setTimeout(() => {
            history.push(`/thank-you/${oppId}`);
          }, 5000);
        }
      })
      .catch((error) => {
        setSnackbarConfig({
          open: true,
          message: ERROR_MESSAGE,
          severity: "error",
        });
      });
  };

  const getBrandImage = () => {
    if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Puravankara
    ) {
      return puravankarLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.Provident
    ) {
      return ProvidentLogo;
    } else if (
      enquiryDetails?.data &&
      enquiryDetails?.data?.projectBrandName === COMPARE_VALUE?.PurvaLand
    ) {
      return PurvaLandLogo;
    }
  };

  const getSignedNames = () => {
    let namesArray = [];
    applicantData?.leegalityData?.invitees?.map((data, index) => {
      return data?.isSigned === true ? namesArray.push(data?.name) : "";
    });

    if (namesArray.length === 0) return "";
    if (namesArray.length === 1) return namesArray[0];

    const allButLast = namesArray.slice(0, -1);
    const lastElement = namesArray.at(-1);

    return `${allButLast.join(", ")} and ${lastElement}`;
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {isLoading && <Loader isLoading={isLoading} />}
      {showThankYouModal ? (
        <ThankYouModal />
      ) : (
        <div
          style={{
            backgroundImage: `url("${
              REACT_APP_S3_BASE_URL + "/" + projectBrandImage
            }")`,
          }}
          className="modalCustomFeedback applicantBackground"
        >
          <div className="modalCustomFeedbackContent">
            <div className="modalCustomFeedbackScroll">
              {/* <span className="customClose">
          <HighlightOffIcon />
        </span> */}
              <div className="logoFeedback">
                <img src={getBrandImage()} alt="Puravankara Logo" />
              </div>
              <Typography
                sx={{
                  fontSize: "24px",
                  fontWeight: "600",
                  color: "#1C252E",
                  mb: 1,
                  textAlign: "center",
                }}
              >
                Thank You
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#1C252E",
                  lineHeight: "22px",
                  mb: "29px",
                  textAlign: "center",
                }}
                className="textAreaMargin"
              >
                {applicantData?.bookingFormStatus ===
                  BOOKING_FORM_STATUS?.PARTIALLY_SIGNED && (
                  <span>
                    Great progress! {getSignedNames()} has signed the booking
                    application form. Once all signatures are in, the PDF will
                    be sent to your registered email.
                  </span>
                )}
                {applicantData?.bookingFormStatus ===
                  BOOKING_FORM_STATUS?.SIGNED && (
                  <span>
                    Congratulations! All applicants have successfully signed the
                    booking application form. The PDF has been sent to your
                    registered email. Keep an eye on your inbox for the next
                    steps.
                  </span>
                )}
                {applicantData?.bookingFormStatus ==
                  BOOKING_FORM_STATUS?.NOT_SIGNED && (
                  <span>
                    We appreciate you taking the time to fill out the form! Once
                    all applicants sign the booking application form, we’ll send
                    the PDF to your registered email IDs. We’re here to help if
                    you need any assistance along the way.
                  </span>
                )}
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#1A407D",
                  lineHeight: "22px",
                  mb: 3,
                  textAlign: "center",
                }}
              >
                How likely are you to recommend a Puravankara Project to your
                friends and family?
              </Typography>
              <Box className="likeDesktop">
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexWrap: {
                      xs: "wrap",
                      sm: "wrap",
                      lg: "nowrap",
                    },
                    width: {
                      xs: "100%",
                      sm: "688px",
                    },
                    margin: {
                      xs: "0 auto 0px auto",
                      sm: "0 auto",
                      lg: "0 auto 8px auto",
                    },
                  }}
                >
                  {ratingList?.map((data) => {
                    return (
                      <button
                        key={data}
                        className={`numberBox ${
                          data === ratingAndFeedback?.rating ? "Active" : ""
                        }`}
                        onClick={() => {
                          setRatingAndFeedback({
                            rating: data,
                            feedback: ratingAndFeedback?.feedback,
                          });
                        }}
                      >
                        {data}
                      </button>
                    );
                  })}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",

                    margin: "0px auto 30px auto",
                    width: {
                      xs: "100%",
                      sm: "688px",
                    },
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#1C252E",
                      lineHeight: "22px",
                      paddingLeft: "8px",
                    }}
                  >
                    👎 Not likely at all
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "#1C252E",
                      lineHeight: "22px",
                      paddingRight: "8px",
                    }}
                  >
                    👍 Extremely likely
                  </Typography>
                </Box>
              </Box>
              <Box className="mobileLike">
                <Slider
                  marks={marks}
                  step={1}
                  value={val}
                  valueLabelDisplay="auto"
                  min={MIN}
                  max={MAX}
                  onChange={handleChange}
                  sx={{
                    height: "10px",
                    "& .MuiSlider-mark": {
                      display: "none",
                    },
                    "& .MuiSlider-thumb": {
                      bgcolor: getSliderColor(val),
                      border: "0px",
                    },
                    "& .MuiSlider-track": {
                      bgcolor: getSliderColor(val),
                      border: "0px",
                    },
                    "& .MuiSlider-rail": {
                      bgcolor: "#ccc",
                      border: "0px",
                    },
                  }}
                />
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    variant="body2"
                    onClick={() => setVal(MIN)}
                    sx={{ cursor: "pointer" }}
                  >
                    👎 Not likely
                  </Typography>
                  <Typography
                    variant="body2"
                    onClick={() => setVal(MAX)}
                    sx={{ cursor: "pointer" }}
                  >
                    👍 Extremely likely
                  </Typography>
                </Box>
              </Box>
              <Box className={"textAreaMargin"}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#1C252E",
                    lineHeight: "22px",
                  }}
                >
                  Please share your booking experience in few words.
                </Typography>
                <TextField
                  multiline
                  rows={3}
                  fullWidth
                  placeholder="Enter details"
                  margin="normal"
                  onChange={(e) => {
                    setRatingAndFeedback({
                      rating: ratingAndFeedback?.rating,
                      feedback: e.target.value,
                    });
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      "& fieldset": {
                        borderColor: "#D0D5DD", // Change border color
                        borderRadius: "8px", // Change border radius
                      },
                      "&:hover fieldset": {
                        borderColor: "#D0D5DD", // Border color on hover
                      },
                      "&.Mui-focused fieldset": {
                        borderColor: "#D0D5DD", // Border color when focused
                      },
                      "& input": {
                        // Target the input element
                        fontSize: "14px", // Change font size (adjust as needed)
                      },
                    },
                    "& .MuiInputBase-input": {
                      // Also adjust the font size in multiline
                      fontSize: "14px", // Change font size (adjust as needed)
                    },
                  }}
                />
              </Box>
              <button
                className={`submitBtn ${
                  ratingAndFeedback?.rating === null ? "disableCTA" : ""
                }`}
                disabled={ratingAndFeedback?.rating === null}
                onClick={() => {
                  handleSubmit();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default FeedbackModal;
